import { RouterService } from '@tokamakjs/common';
import { HookService } from '@tokamakjs/react';

import { AuthApi } from '~/api';

@HookService()
export class AuthGuard {
  constructor(private readonly _routerService: RouterService, private readonly _authApi: AuthApi) {}

  public canActivate(): boolean {
    const { pathname: internalPathName, search } = this._routerService.location;
    const { pathname: externalPathName } = window.location;

    if (
      internalPathName.startsWith('/login') ||
      internalPathName.startsWith('/sign-up') ||
      internalPathName.startsWith('/reset-password')
    ) {
      return true;
    }

    const user = this._authApi.getUserFromLocalToken();

    if (user == null) {
      if (search.includes('code')) {
        this._routerService.push(`/sign-up${search}`);
      } else {
        this._routerService.push(`/login?next=${externalPathName + search}`);
      }

      return false;
    } else if (!user.confirmed) {
      if (internalPathName.startsWith('/confirmation')) {
        return true;
      }

      this._routerService.push(
        `/confirmation${
          internalPathName.includes('confirmation') ? search : `?next=${externalPathName + search}`
        }`,
      );

      return false;
    }
    // checking for object details due to backend issue
    else if (user.organisation == null || user.organisation.id == null) {
      if (internalPathName.startsWith('/create-join-company')) {
        return true;
      }

      this._routerService.push(
        `/create-join-company${
          internalPathName.includes('create-join-company') ||
          internalPathName.includes('confirmation')
            ? search
            : `?next=${externalPathName + search}`
        }`,
      );

      return false;
    }

    return true;
  }
}
